import '../styles/landing.css'

export default function Footer() {
  return (
    <footer style={{
      background: 'var(--bg-secondary)',
      borderTop: '1px solid var(--border)',
      padding: 'var(--spacing-2xl) 0',
      marginTop: 'var(--spacing-3xl)'
    }}>
      <div className="container">
        <div className="grid grid-3">
          {/* Company Info */}
          <div className="footer-section">
            <div className="flex flex-center mb-md" style={{ alignItems: 'center' }}>
              <img 
                src="/icons/logo.png" 
                alt="Ascensos App" 
                style={{ 
                  height: '32px',
                  filter: 'brightness(1) invert(0)'
                }}
              />
              <span className="footer-logo-title">
                Ascensos App
              </span>
            </div>
            <p className="footer-desc">
              La app que te ayuda a planificar, estudiar y alcanzar tu ascenso.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Enlaces rápidos</h4>
            <div className="footer-links">
              <a href="#about">Sobre nosotros</a>
              <a href="#features">Características</a>
              <a href="#howitworks">Cómo funciona</a>
              <a href="#availability">Descargar</a>
            </div>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4>Contacto</h4>
            <div className="footer-links">
              <a href="mailto:ascensosappvortex@gmail.com">
                ascensosappvortex@gmail.com
              </a>
              <a href="#contact">
                Formulario de contacto
              </a>
              <a href="/politica-privacidad" target="_blank" rel="noopener noreferrer">
                Política de Privacidad y Términos
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          © {new Date().getFullYear()} Ascensos App. Derechos en trámite.
        </div>
      </div>
    </footer>
  )
}